const planCards = {
  status: "OK",
  message: "SUCCESS",
  data: {
    plans: [
      {
        seqNum: 1,
        name: "Wipro Health Medicare Discover Plus (PPO)",
        productName: "Medicare Advantage",
        type: "PPO",
        desc: "$250 Rx Ded",
        rating: 0,
        ratingComment: "Plan too new to be measured",
        monthlyPremium: "50.17",
        copayList: [
          "$0 in-network / 30% out-of-network PCP",
          "$40 in-network / 30% out-of-network Specialist",
        ],
      },
      {
        seqNum: 2,
        name: "Wipro Gold Plus H6622-073 (HMO-POS)",
        productName: "Medicare Part D",
        type: "HMO",
        desc: "$350 Rx Ded",
        rating: 4,
        ratingComment: "4 out of 5 stars",
        monthlyPremium: "68.21",
        copayList: ["$10 copay PCP", "$45 copay Specialist"],
      },
      {
        seqNum: 3,
        name: "Wipro Value Plus H5216-176 (PPO)",
        productName: "Medicare Advantage only",
        type: "PPO",
        desc: "$230 Rx Ded",
        rating: 4,
        ratingComment: "4 out of 5 stars",
        monthlyPremium: "28.60",
        copayList: ["$20 copay PCP", "$50 copay Specialist"],
      },
    ],
  },
  errorCode: 0,
};

const planDetails = {
  status: "OK",
  message: "SUCCESS",
  data: [
    [
      {
        seqNum: 1,
        name: "Wipro Health Medicare Discover Plus (PPO)",
        rating: 0,
        ratingComment: "Plan too new to be measured",
        monthlyPremium: "$50.17",
      },
      {
        key: "premium",
        value:
          "Total monthly premium: $0.00<br/>Health plan premium: $0.00<br/>Drug plan premium: $0.00<br/>Standard Part B premium: $148.50",
      },
      {
        key: "deductible",
        value:
          "Health plan deductible: $0.00<br/>Drug plan deductible: $250.00",
      },
      { key: "estimatedYearlyCosts", value: "" },
      {
        key: "outOfPocketMax",
        value:
          "Out-of-pocket max: In-network: $5900.00, In and Out-of-network: $10000.00",
      },
      {
        key: "doctorServices",
        value:
          "Primary doctor visit: $0 in-network / 30% out-of-network<p>Specialist visit: $40 in-network / 30% out-of-network)",
      },
      {
        key: "testsLabsAndImaging",
        value:
          "Diagnostic tests & procedures: Diagnostic Procedures/Tests: $45 in-network/ Diagnostic Procedures/Tests Covid: $0 in-network/ 30% out-of-network, for more information see Evidence of Coverage<p>Lab services: Lab Services: $0 in-network/ Lab Services Covid: $0 in-network/ 30% out-of-network, for more information see Evidence of Coverage<p>Diagnostic radiology services (like MRI): In-network: $0 to $200, Out-of-network: 30% coinsurance<p>Outpatient x-rays: In-network: $45, Out-of-network: 30% coinsurance<p>Emergency care: $90 If you are admitted to the hospital within 0 hours your cost share may be waived, for more information see the Evidence of Coverage<p>Urgent care: $0 to $40 (always covered)",
      },
      {
        key: "hospitalServices",
        value:
          "Inpatient hospital coverage: $365 per day, days 1-5; $0 per day, days 6-90 in-network / 30% per stay out-of-network<p>Outpatient hospital coverage: In-network: $0 to $400, Out-of-network: 30% coinsurance",
      },
      {
        key: "skilledNursingFacility",
        value:
          "Skilled nursing facility: $0 per day, days 1-20; $172 per day, days 21-100 in-network/ 20% per stay out-of-network, for more information see Evidence of Coverage",
      },
      {
        key: "preventiveServices",
        value:
          "Preventive services: $0 copay for all preventive services covered under Original Medicare at zero cost sharing",
      },
      {
        key: "ambulance",
        value: "Ambulance: $315 in-network / $315 out-of-network",
      },
      {
        key: "therapyServices",
        value:
          "Occupational therapy visit: In-network: $40, Out-of-network: 30% coinsurance<p>Physical therapy & speech & language therapy visit: In-network: $40, Out-of-network: 30% coinsurance",
      },
      {
        key: "mentalHealthServices",
        value:
          "Outpatient group therapy with a psychiatrist: In-network: $40, Out-of-network: 30% coinsurance<p>Outpatient individual therapy with a psychiatrist: In-network: $40, Out-of-network: 30% coinsurance<p>Outpatient group therapy visit: In-network: $40, Out-of-network: 30% coinsurance<p>Outpatient individual therapy visit: In-network: $40, Out-of-network: 30% coinsurance",
      },
      {
        key: "opioidTrtmntProgramServices",
        value:
          "Opioid treatment program services: In-network: $40, Out-of-network: 30% coinsurance",
      },
      { key: "opioidTrtmntServices", value: "" },
      {
        key: "otherServices",
        value:
          "Durable medical equipment (like wheelchairs & oxygen):20% in-network / 20% out-of-network<p>Prosthetics (like braces, artificial limbs):In-network: 20%, Out-of-network: 20% coinsurance<p>Diabetes supplies:0% - 20% Higher cost-share applies to non-OneTouch/LifeScan diabetic supplies.",
      },
      {
        key: "hearing",
        value:
          "Hearing exam: In-network: $40 copay Out-of-network: 30% coinsurance<p>Fitting/evaluation: In-network: $0 copay Out-of-network: 30% coinsurance, Limits apply<p>Hearing aids - All types: In-network: $0 copay Out-of-network: $0 copay, Limits apply",
      },
      {
        key: "preventiveDental",
        value:
          "Oral exam: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Cleaning: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Fluoride treatment: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Dental x-rays: In-network: $0 copay Out-of-network: $0 copay, Limits apply",
      },
      {
        key: "comprehensiveDental",
        value:
          "Non-routine services: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Diagnostic services: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Restorative services: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Endodontics: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Periodontics: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Extractions: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Prosthodontics, other oral/maxillofacial surgery, other services: In-network: $0 copay Out-of-network: $0 copay, Limits apply",
      },
      {
        key: "vision",
        value:
          "Routine eye exam: In-network: $0 copay Out-of-network: 30% coinsurance, Limits apply<p>Contact lenses: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Eyeglasses (frames & lenses): In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Eyeglass frames (only): In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Eyeglass lenses (only): In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Upgrades: In-network: $0 copay Out-of-network: $0 copay, Limits apply",
      },
      {
        key: "moreBenefits",
        value:
          "Fitness benefit: Memberships at participating fitness facilities at no added cost to you. Also access to online wellness related tools, planners, newsletters, and classes.<p>Over the counter drug benefits: $30 every month, for more information see Evidence of Coverage<p>In-home support services: $0 in-network / 30% out-of-network<p>Home and bathroom safety devices: Not Covered<p>Meals for short duration: $0 copay for 14 meals over 7 days after an inpatient discharge, for more information see Evidence of Coverage<p>Routine chiropractic service: Some Coverage<p>Annual physical exams: $0 in-network / 30% out-of-network<p>Telehealth: Some Coverage<p>Transportation services for non-emergency care: Not Covered",
      },
      { key: "medApprNonOpioidPainMgmtServices", value: "" },
      {
        key: "partBDrugs",
        value:
          "Chemotherapy drugs: In-network: 20%, Out-of-network: 30% coinsurance<p>Other Part B drugs: In-network: 20%, Out-of-network: 30% coinsurance",
      },
      { key: "optionalPackages", value: "" },
      {
        prescriptionDrugs: {
          PrefMailCostSharing: [
            ["$0.00 copay", "$0.00 copay"],
            ["$20.00 copay", "$60.00 copay"],
            ["$47.00 copay", "$141.00 copay"],
            ["$100.00 copay", "$300.00 copay"],
            ["28%", ""],
          ],
          stdRtlCostSharing: [
            ["$15.00 copay", "$45.00 copay"],
            ["$20.00 copay", "$60.00 copay"],
            ["$47.00 copay", "$141.00 copay"],
            ["$100.00 copay", "$300.00 copay"],
            ["28%", ""],
          ],
          PrefRtlCostSharing: [
            ["$0.00 copay", "$0.00 copay"],
            ["$5.00 copay", "$10.00 copay"],
            ["$47.00 copay", "$141.00 copay"],
            ["$100.00 copay", "$300.00 copay"],
            ["28%", ""],
          ],
          stdMailCostSharing: [
            ["$15.00 copay", "$45.00 copay"],
            ["$20.00 copay", "$60.00 copay"],
            ["$47.00 copay", "$141.00 copay"],
            ["$100.00 copay", "$300.00 copay"],
            ["28%", ""],
          ],
        },
      },
    ],
    [
      {
        seqNum: 2,
        name: "Wipro Health Medicare Discover Plus (PPO)",
        rating: 4,
        ratingComment: "4 out of 5 stars",
        monthlyPremium: "$45.50",
      },
      {
        key: "premium",
        value:
          "Total monthly premium: $0.00<br/>Health plan premium: $0.00<br/>Drug plan premium: $0.00<br/>Standard Part B premium: $148.50<br/>Part B premium reduction: No",
      },
      {
        key: "deductible",
        value:
          "Health plan deductible: $0.00<br/>Drug plan deductible: $350.00",
      },
      {
        key: "estimatedYearlyCosts",
        value: "Estimated total yearly costs for care: $3,523.00",
      },
      {
        key: "outOfPocketMax",
        value:
          "Out-of-pocket max: In-network: $5500.00, In and Out-of-network: $8000.00",
      },
      {
        key: "doctorServices",
        value:
          "Primary doctor visit: In-network: $10 copay, Out-of-network: 30% coinsurance<p>Specialist visit: In-network: $45 copay, Out-of-network: 30% coinsurance, Limits apply",
      },
      {
        key: "testsLabsAndImaging",
        value:
          "Diagnostic tests & procedures: In-network: $0-95 copay, Out-of-network: $0 copay or 30% coinsurance, Limits apply<p>Lab services: In-network: $0-45 copay, Out-of-network: 30% coinsurance, Limits apply<p>Diagnostic radiology services (like MRI): In-network: $45-350 copay, Out-of-network: 30% coinsurance, Limits apply<p>Outpatient x-rays: In-network: $10-95 copay, Out-of-network: 30% coinsurance, Limits apply<p>Emergency care: $90 copay per visit (always covered)<p>Urgent care: $10-45 copay or 30% coinsurance per visit (always covered)",
      },
      {
        key: "hospitalServices",
        value:
          "Inpatient hospital coverage: In-network: $350 copay per day for days 1 through 5, $0 copay per day for days 6 through 90, $0 copay per day for days 91 and beyond, Out-of-network: 30% coinsurance per stay, Limits apply<p>Outpatient hospital coverage: In-network: $45-350 copay per visit, Out-of-network: 30% coinsurance per visit, Limits apply",
      },
      {
        key: "skilledNursingFacility",
        value:
          "Skilled nursing facility: In-network: $0 copay per day for days 1 through 20, $184 copay per day for days 21 through 100, Out-of-network: 30% coinsurance per stay, Limits apply",
      },
      {
        key: "preventiveServices",
        value:
          "Preventive services: In-network: $0 copay, Out-of-network: $0 copay or 30% coinsurance",
      },
      {
        key: "ambulance",
        value:
          "Ground Ambulance: In-network: $290 copay, Out-of-network: $290 copay",
      },
      {
        key: "therapyServices",
        value:
          "Occupational therapy visit: In-network: $40 copay, Out-of-network: 30% coinsurance, Limits apply<p>Physical therapy & speech & language therapy visit: In-network: $40 copay, Out-of-network: 30% coinsurance, Limits apply",
      },
      {
        key: "mentalHealthServices",
        value:
          "Outpatient group therapy with a psychiatrist: In-network: $40 copay, Out-of-network: 30% coinsurance, Limits apply<p>Outpatient individual therapy with a psychiatrist: In-network: $40 copay, Out-of-network: 30% coinsurance, Limits apply<p>Outpatient group therapy visit: In-network: $40 copay, Out-of-network: 30% coinsurance, Limits apply<p>Outpatient individual therapy visit: In-network: $40 copay, Out-of-network: 30% coinsurance, Limits apply",
      },
      { key: "opioidTrtmntProgramServices", value: "" },
      {
        key: "opioidTrtmntServices",
        value:
          "Opioid treatment services: In-network: $40-95 copay, Out-of-network: 30% coinsurance, Limits apply",
      },
      {
        key: "otherServices",
        value:
          "Durable medical equipment (like wheelchairs & oxygen): In-network: 20% coinsurance, Out-of-network: 30% coinsurance, Limits apply<p>Prosthetics (like braces, artificial limbs): In-network: 20% coinsurance, Out-of-network: 30% coinsurance, Limits apply<p>Dialysis: In-network: 20% coinsurance, Out-of-network: 30% coinsurance, Limits apply<p>Diabetes supplies: In-network: $0 copay or 10-20% coinsurance, Out-of-network: 30% coinsurance, Limits apply<p>Senior Savings Model (capped Insulin cost): Yes",
      },
      {
        key: "hearing",
        value:
          "Medicare-covered Hearing exam: In-network: $45 copay, Out-of-network: 30% coinsurance<p>Routine Hearing exam: In-network: $0 copay, Out-of-network: $0 copay, Limits apply<p>Fitting/evaluation: In-network: $0 copay, Out-of-network: $0 copay, Limits apply<p>Hearing aids - All types: In-network: $699-999 copay, Out-of-network: $699-999 copay, Limits apply",
      },
      {
        key: "preventiveDental",
        value:
          "Oral exam: In-network: 0% coinsurance, Out-of-network: 50% coinsurance, Limits apply<p>Cleaning: In-network: 0% coinsurance, Out-of-network: 50% coinsurance, Limits apply<p>Fluoride treatment: Not covered<p>Dental x-rays: In-network: 0% coinsurance, Out-of-network: 50% coinsurance, Limits apply",
      },
      {
        key: "comprehensiveDental",
        value:
          "Non-routine services: Not covered<p>Diagnostic services: Not covered<p>Restorative services: Not covered<p>Endodontics: Not covered<p>Periodontics: Not covered<p>Extractions: Not covered<p>Prosthodontics, other oral/maxillofacial surgery, other services: Not covered",
      },
      {
        key: "vision",
        value:
          "Medicare-covered eye exam: In-network: $0-45 copay, Out-of-network: 30% coinsurance<p>Routine eye exam: In-network: $0 copay, Out-of-network: $0 copay, Limits apply<p>Contact lenses: In-network: $0 copay, Out-of-network: $0 copay, Limits apply<p>Eyeglasses (frames & lenses): In-network: $0 copay, Out-of-network: $0 copay, Limits apply<p>Eyeglass frames (only): Not covered<p>Eyeglass lenses (only): Not coveredp>Upgrades: Not covered",
      },
      {
        key: "moreBenefits",
        value:
          "Fitness benefit: Some Coverage<p>Over the counter drug benefits: Some Coverage<p>In-home support services: Not covered<p>Home and bathroom safety devices: Not covered<p>Meals for short duration: Some Coverage<p>Routine chiropractic service: Not covered<p>Annual physical exams: Some Coverage<p>Telehealth: Some Coverage<p>Transportation services for non-emergency care: Plan-approved locations: Not covered<p>Transportation services for non-emergency care: Any health-related locations: Not covered<p>Worldwide emergency: Some coverage",
      },
      {
        key: "medApprNonOpioidPainMgmtServices",
        value:
          "Chiropractic services: Not covered<p>Acupuncture: Not covered<p>Massage therapy: Not covered<p>Alternative therapies: Not covered",
      },
      {
        key: "partBDrugs",
        value:
          "Chemotherapy drugs: In-network: 20% coinsurance, Out-of-network: 30% coinsurance, Limits apply<p>Other Part B drugs: In-network: 20% coinsurance, Out-of-network: 30% coinsurance, Limits apply",
      },
      {
        key: "optionalPackages",
        value:
          "Package #1 MyOption Enhanced Dental HMO<br/>Includes: Comprehensive Dental*, Preventive Dental*<br/>Monthly Premium: $32.40",
      },
      {
        prescriptionDrugs: {
          PrefMailCostSharing: [
            ["$0.00 copay", "$0.00 copay"],
            ["$20.00 copay", "$60.00 copay"],
            ["$47.00 copay", "$141.00 copay"],
            ["$100.00 copay", "$300.00 copay"],
            ["28%", ""],
          ],
          stdRtlCostSharing: [
            ["$15.00 copay", "$45.00 copay"],
            ["$20.00 copay", "$60.00 copay"],
            ["$47.00 copay", "$141.00 copay"],
            ["$100.00 copay", "$300.00 copay"],
            ["28%", ""],
          ],
          PrefRtlCostSharing: [
            ["$0.00 copay", "$0.00 copay"],
            ["$5.00 copay", "$10.00 copay"],
            ["$47.00 copay", "$141.00 copay"],
            ["$100.00 copay", "$300.00 copay"],
            ["28%", ""],
          ],
          stdMailCostSharing: [
            ["$15.00 copay", "$45.00 copay"],
            ["$20.00 copay", "$60.00 copay"],
            ["$47.00 copay", "$141.00 copay"],
            ["$100.00 copay", "$300.00 copay"],
            ["28%", ""],
          ],
        },
      },
    ],
  ],
  errorCode: 0,
};

const planDet = {
  status: "OK",
  message: "SUCCESS",
  data: [
    {
      seqNum: 1,
      name: "Wipro Health Medicare Discover Plus (PPO)",
      rating: 0,
      ratingComment: "Plan too new to be measured",
      monthlyPremium: "$50.17",
      premium:
        "Total monthly premium: $0.00<br/>Health plan premium: $0.00<br/>Drug plan premium: $0.00<br/>Standard Part B premium: $148.50",
      deductible:
        "Health plan deductible: $0.00<br/>Drug plan deductible: $250.00",
      estimatedYearlyCosts: "",
      outOfPocketMax:
        "Out-of-pocket max: In-network: $5900.00, In and Out-of-network: $10000.00",
      doctorServices:
        "Primary doctor visit: $0 in-network / 30% out-of-network<p>Specialist visit: $40 in-network / 30% out-of-network",
      testsLabsAndImaging:
        "Diagnostic tests & procedures: Diagnostic Procedures/Tests: $45 in-network/ Diagnostic Procedures/Tests Covid: $0 in-network/ 30% out-of-network, for more information see Evidence of Coverage<p>Lab services: Lab Services: $0 in-network/ Lab Services Covid: $0 in-network/ 30% out-of-network, for more information see Evidence of Coverage<p>Diagnostic radiology services (like MRI): In-network: $0 to $200, Out-of-network: 30% coinsurance<p>Outpatient x-rays: In-network: $45, Out-of-network: 30% coinsurance<p>Emergency care: $90 If you are admitted to the hospital within 0 hours your cost share may be waived, for more information see the Evidence of Coverage<p>Urgent care: $0 to $40 (always covered)",
      hospitalServices:
        "Inpatient hospital coverage: $365 per day, days 1-5; $0 per day, days 6-90 in-network / 30% per stay out-of-network<p>Outpatient hospital coverage: In-network: $0 to $400, Out-of-network: 30% coinsurance",
      skilledNursingFacility:
        "Skilled nursing facility: $0 per day, days 1-20; $172 per day, days 21-100 in-network/ 20% per stay out-of-network, for more information see Evidence of Coverage",
      preventiveServices:
        "Preventive services: $0 copay for all preventive services covered under Original Medicare at zero cost sharing",
      ambulance: "Ambulance: $315 in-network / $315 out-of-network",
      therapyServices:
        "Occupational therapy visit: In-network: $40, Out-of-network: 30% coinsurance<p>Physical therapy & speech & language therapy visit: In-network: $40, Out-of-network: 30% coinsurance",
      mentalHealthServices:
        "Outpatient group therapy with a psychiatrist: In-network: $40, Out-of-network: 30% coinsurance<p>Outpatient individual therapy with a psychiatrist: In-network: $40, Out-of-network: 30% coinsurance<p>Outpatient group therapy visit: In-network: $40, Out-of-network: 30% coinsurance<p>Outpatient individual therapy visit: In-network: $40, Out-of-network: 30% coinsurance",
      opioidTrtmntProgramServices:
        "Opioid treatment program services: In-network: $40, Out-of-network: 30% coinsurance",
      opioidTrtmntServices: "",
      otherServices:
        "Durable medical equipment (like wheelchairs & oxygen):20% in-network / 20% out-of-network<p>Prosthetics (like braces, artificial limbs):In-network: 20%, Out-of-network: 20% coinsurance<p>Diabetes supplies:0% - 20% Higher cost-share applies to non-OneTouch/LifeScan diabetic supplies.",
      hearing:
        "Hearing exam: In-network: $40 copay Out-of-network: 30% coinsurance<p>Fitting/evaluation: In-network: $0 copay Out-of-network: 30% coinsurance, Limits apply<p>Hearing aids - All types: In-network: $0 copay Out-of-network: $0 copay, Limits apply",
      preventiveDental:
        "Oral exam: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Cleaning: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Fluoride treatment: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Dental x-rays: In-network: $0 copay Out-of-network: $0 copay, Limits apply",
      comprehensiveDental:
        "Non-routine services: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Diagnostic services: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Restorative services: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Endodontics: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Periodontics: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Extractions: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Prosthodontics, other oral/maxillofacial surgery, other services: In-network: $0 copay Out-of-network: $0 copay, Limits apply",
      vision:
        "Routine eye exam: In-network: $0 copay Out-of-network: 30% coinsurance, Limits apply<p>Contact lenses: In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Eyeglasses (frames & lenses): In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Eyeglass frames (only): In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Eyeglass lenses (only): In-network: $0 copay Out-of-network: $0 copay, Limits apply<p>Upgrades: In-network: $0 copay Out-of-network: $0 copay, Limits apply",
      moreBenefits:
        "Fitness benefit: Memberships at participating fitness facilities at no added cost to you. Also access to online wellness related tools, planners, newsletters, and classes.<p>Over the counter drug benefits: $30 every month, for more information see Evidence of Coverage<p>In-home support services: $0 in-network / 30% out-of-network<p>Home and bathroom safety devices: Not Covered<p>Meals for short duration: $0 copay for 14 meals over 7 days after an inpatient discharge, for more information see Evidence of Coverage<p>Routine chiropractic service: Some Coverage<p>Annual physical exams: $0 in-network / 30% out-of-network<p>Telehealth: Some Coverage<p>Transportation services for non-emergency care: Not Covered",
      medApprNonOpioidPainMgmtServices: "",
      partBDrugs:
        "Chemotherapy drugs: In-network: 20%, Out-of-network: 30% coinsurance<p>Other Part B drugs: In-network: 20%, Out-of-network: 30% coinsurance",
      optionalPackages: "",
      prescriptionDrugs: {
        PrefMailCostSharing: [
          ["$0.00 copay", "$0.00 copay"],
          ["$20.00 copay", "$60.00 copay"],
          ["$47.00 copay", "$141.00 copay"],
          ["$100.00 copay", "$300.00 copay"],
          ["28%", ""],
        ],
        stdRtlCostSharing: [
          ["$15.00 copay", "$45.00 copay"],
          ["$20.00 copay", "$60.00 copay"],
          ["$47.00 copay", "$141.00 copay"],
          ["$100.00 copay", "$300.00 copay"],
          ["28%", ""],
        ],
        PrefRtlCostSharing: [
          ["$0.00 copay", "$0.00 copay"],
          ["$5.00 copay", "$10.00 copay"],
          ["$47.00 copay", "$141.00 copay"],
          ["$100.00 copay", "$300.00 copay"],
          ["28%", ""],
        ],
        stdMailCostSharing: [
          ["$15.00 copay", "$45.00 copay"],
          ["$20.00 copay", "$60.00 copay"],
          ["$47.00 copay", "$141.00 copay"],
          ["$100.00 copay", "$300.00 copay"],
          ["28%", ""],
        ],
      },
    },
    {
      seqNum: 2,
      name: "Wipro Health Medicare Discover Plus (PPO)",
      rating: 4,
      ratingComment: "4 out of 5 stars",
      monthlyPremium: "$45.50",
      premium:
        "Total monthly premium: $0.00<br/>Health plan premium: $0.00<br/>Drug plan premium: $0.00<br/>Standard Part B premium: $148.50<br/>Part B premium reduction: No",
      deductible:
        "Health plan deductible: $0.00<br/>Drug plan deductible: $350.00",
      estimatedYearlyCosts: "Estimated total yearly costs for care: $3,523.00",
      outOfPocketMax:
        "Out-of-pocket max: In-network: $5500.00, In and Out-of-network: $8000.00",
      doctorServices:
        "Primary doctor visit: In-network: $10 copay, Out-of-network: 30% coinsurance<p>Specialist visit: In-network: $45 copay, Out-of-network: 30% coinsurance, Limits apply",
      testsLabsAndImaging:
        "Diagnostic tests & procedures: In-network: $0-95 copay, Out-of-network: $0 copay or 30% coinsurance, Limits apply<p>Lab services: In-network: $0-45 copay, Out-of-network: 30% coinsurance, Limits apply<p>Diagnostic radiology services (like MRI): In-network: $45-350 copay, Out-of-network: 30% coinsurance, Limits apply<p>Outpatient x-rays: In-network: $10-95 copay, Out-of-network: 30% coinsurance, Limits apply<p>Emergency care: $90 copay per visit (always covered)<p>Urgent care: $10-45 copay or 30% coinsurance per visit (always covered)",
      hospitalServices:
        "Inpatient hospital coverage: In-network: $350 copay per day for days 1 through 5, $0 copay per day for days 6 through 90, $0 copay per day for days 91 and beyond, Out-of-network: 30% coinsurance per stay, Limits apply<p>Outpatient hospital coverage: In-network: $45-350 copay per visit, Out-of-network: 30% coinsurance per visit, Limits apply",
      skilledNursingFacility:
        "Skilled nursing facility: In-network: $0 copay per day for days 1 through 20, $184 copay per day for days 21 through 100, Out-of-network: 30% coinsurance per stay, Limits apply",
      preventiveServices:
        "Preventive services: In-network: $0 copay, Out-of-network: $0 copay or 30% coinsurance",
      ambulance:
        "Ground Ambulance: In-network: $290 copay, Out-of-network: $290 copay",
      therapyServices:
        "Occupational therapy visit: In-network: $40 copay, Out-of-network: 30% coinsurance, Limits apply<p>Physical therapy & speech & language therapy visit: In-network: $40 copay, Out-of-network: 30% coinsurance, Limits apply",
      mentalHealthServices:
        "Outpatient group therapy with a psychiatrist: In-network: $40 copay, Out-of-network: 30% coinsurance, Limits apply<p>Outpatient individual therapy with a psychiatrist: In-network: $40 copay, Out-of-network: 30% coinsurance, Limits apply<p>Outpatient group therapy visit: In-network: $40 copay, Out-of-network: 30% coinsurance, Limits apply<p>Outpatient individual therapy visit: In-network: $40 copay, Out-of-network: 30% coinsurance, Limits apply",
      opioidTrtmntProgramServices: "",
      opioidTrtmntServices:
        "Opioid treatment services: In-network: $40-95 copay, Out-of-network: 30% coinsurance, Limits apply",
      otherServices:
        "Durable medical equipment (like wheelchairs & oxygen): In-network: 20% coinsurance, Out-of-network: 30% coinsurance, Limits apply<p>Prosthetics (like braces, artificial limbs): In-network: 20% coinsurance, Out-of-network: 30% coinsurance, Limits apply<p>Dialysis: In-network: 20% coinsurance, Out-of-network: 30% coinsurance, Limits apply<p>Diabetes supplies: In-network: $0 copay or 10-20% coinsurance, Out-of-network: 30% coinsurance, Limits apply<p>Senior Savings Model (capped Insulin cost): Yes",
      hearing:
        "Medicare-covered Hearing exam: In-network: $45 copay, Out-of-network: 30% coinsurance<p>Routine Hearing exam: In-network: $0 copay, Out-of-network: $0 copay, Limits apply<p>Fitting/evaluation: In-network: $0 copay, Out-of-network: $0 copay, Limits apply<p>Hearing aids - All types: In-network: $699-999 copay, Out-of-network: $699-999 copay, Limits apply",
      preventiveDental:
        "Oral exam: In-network: 0% coinsurance, Out-of-network: 50% coinsurance, Limits apply<p>Cleaning: In-network: 0% coinsurance, Out-of-network: 50% coinsurance, Limits apply<p>Fluoride treatment: Not covered<p>Dental x-rays: In-network: 0% coinsurance, Out-of-network: 50% coinsurance, Limits apply",
      comprehensiveDental:
        "Non-routine services: Not covered<p>Diagnostic services: Not covered<p>Restorative services: Not covered<p>Endodontics: Not covered<p>Periodontics: Not covered<p>Extractions: Not covered<p>Prosthodontics, other oral/maxillofacial surgery, other services: Not covered",
      vision:
        "Medicare-covered eye exam: In-network: $0-45 copay, Out-of-network: 30% coinsurance<p>Routine eye exam: In-network: $0 copay, Out-of-network: $0 copay, Limits apply<p>Contact lenses: In-network: $0 copay, Out-of-network: $0 copay, Limits apply<p>Eyeglasses (frames & lenses): In-network: $0 copay, Out-of-network: $0 copay, Limits apply<p>Eyeglass frames (only): Not covered<p>Eyeglass lenses (only): Not coveredp>Upgrades: Not covered",
      moreBenefits:
        "Fitness benefit: Some Coverage<p>Over the counter drug benefits: Some Coverage<p>In-home support services: Not covered<p>Home and bathroom safety devices: Not covered<p>Meals for short duration: Some Coverage<p>Routine chiropractic service: Not covered<p>Annual physical exams: Some Coverage<p>Telehealth: Some Coverage<p>Transportation services for non-emergency care: Plan-approved locations: Not covered<p>Transportation services for non-emergency care: Any health-related locations: Not covered<p>Worldwide emergency: Some coverage",
      medApprNonOpioidPainMgmtServices:
        "Chiropractic services: Not covered<p>Acupuncture: Not covered<p>Massage therapy: Not covered<p>Alternative therapies: Not covered",
      partBDrugs:
        "Chemotherapy drugs: In-network: 20% coinsurance, Out-of-network: 30% coinsurance, Limits apply<p>Other Part B drugs: In-network: 20% coinsurance, Out-of-network: 30% coinsurance, Limits apply",
      optionalPackages:
        "Package #1 MyOption Enhanced Dental HMO<br/>Includes: Comprehensive Dental*, Preventive Dental*<br/>Monthly Premium: $32.40",
      prescriptionDrugs: {
        PrefMailCostSharing: [
          ["$15.00 copay", "$15.00 copay"],
          ["$15.00 copay", "$15.00 copay"],
          ["$15.00 copay", "$15.00 copay"],
          ["$15.00 copay", "$15.00 copay"],
          ["$15.00 copay", "$15.00 copay"],
        ],
        PrefRtlCostSharing: [
          ["$5.00 copay", "$15.00 copay"],
          ["$10.00 copay", "$30.00 copay"],
          ["$47.00 copay", "$141.00 copay"],
          ["$100.00 copay", "$300.00 copay"],
          ["26%", ""],
        ],
        stdMailCostSharing: [
          ["$5.00 copay", "$15.00 copay"],
          ["$10.00 copay", "$30.00 copay"],
          ["$47.00 copay", "$141.00 copay"],
          ["$100.00 copay", "$300.00 copay"],
          ["26%", ""],
        ],
        stdRtlCostSharing: [
          ["$5.00 copay", "$15.00 copay"],
          ["$10.00 copay", "$30.00 copay"],
          ["$47.00 copay", "$141.00 copay"],
          ["$100.00 copay", "$300.00 copay"],
          ["26%", ""],
        ],
      },
    },
  ],
  errorCode: 0,
};
const planDetailHeader = [
  {
    key: "premium",
    value: "Premium",
  },
  {
    key: "deductible",
    value: "Deductable",
  },
  {
    key: "estimatedYearlyCosts",
    value: "Estimated Yearly Costs",
  },
];

// const planCards = {
//   status: "OK",
//   message: "SUCCESS",
//   data: [
//     {
//       planName: "Wipro Health Medicare Discover Plus (PPO)",
//       category: "Medicare Advantage",
//       rating: "",
//       ratingComment: "Plan too new to be measured",
//       monPremium: "0.00",
//       type: "PPO",
//       typedetail: "250",
//       copay: [
//         "0 in-network / 30% out-of-network PCP",
//         "40 in-network / 30% out-of-network Specialist",
//       ],
//     },
//     {
//       planName: "Wipro Gold Plus H6622-073 (HMO-POS)",
//       category: "Medicare Part D",
//       rating: "4",
//       ratingComment: "4 out of 5 stars",
//       monPremium: "0.00",
//       type: "HMO",
//       typedetail: "350",
//       copay: ["10 copay PCP", "45 copay Specialist"],
//     },
//     {
//       planName: "Wipro Value Plus H5216-176 (PPO)",
//       category: "Medicare Advantage only",
//       rating: "4",
//       ratingComment: "4 out of 5 stars",
//       monPremium: "28.60",
//       type: "PPO",
//       typedetail: "230",
//       copay: ["20 copay PCP", "50 copay Specialist"],
//     },
//   ],
// };
// export default planCards;

const chartDataCategory = {
  SUBMITTED: [
    {
      activationDate: null,
      ageingDays: 0,
      applId: 2125,
      applStatus: "SUBMITTED",
      applType: "NMA",
      assignedToUser: "",
      birthDate: "09/05/1938",
      firstName: "PAMELA",
      lastName: "ROBTEST",
      medicareId: "1W11PR0TP05",
      prodName: "VIRGINIA PREMIER ADVANTAGE PLATINUM",
      recieveDate: "04/30/2021",
    },
  ],
  INPROGRESS: [
    {
      activationDate: null,
      ageingDays: 0,
      applId: 2125,
      applStatus: "INPROGRESS",
      applType: "NMA",
      assignedToUser: "",
      birthDate: "09/05/1938",
      firstName: "PAMELA",
      lastName: "ROBTEST",
      medicareId: "1W11PR0TP05",
      prodName: "VIRGINIA PREMIER ADVANTAGE PLATINUM",
      recieveDate: "04/30/2021",
    },
  ],
};

const chartData = {
  CANCELED: [
    {
      activationDate: null,
      ageingDays: 0,
      applId: 2125,
      applStatus: "CANCELED",
      applType: "NMA",
      assignedToUser: "",
      birthDate: "09/05/1938",
      firstName: "PAMELA",
      lastName: "ROBTEST",
      medicareId: "1W11PR0TP05",
      prodName: "VIRGINIA PREMIER ADVANTAGE PLATINUM",
      recieveDate: "04/30/2021",
    },
  ],
  ACTIVE: [
    {
      activationDate: null,
      ageingDays: 0,
      applId: 2125,
      applStatus: "CANCELED",
      applType: "NMA",
      assignedToUser: "",
      birthDate: "09/05/1938",
      firstName: "PAMELA",
      lastName: "ROBTEST",
      medicareId: "1W11PR0TP05",
      prodName: "VIRGINIA PREMIER ADVANTAGE PLATINUM",
      recieveDate: "04/30/2021",
    },
  ],
  ONHOLD: [
    {
      activationDate: null,
      ageingDays: 0,
      applId: 2125,
      applStatus: "CANCELED",
      applType: "NMA",
      assignedToUser: "",
      birthDate: "09/05/1938",
      firstName: "PAMELA",
      lastName: "ROBTEST",
      medicareId: "1W11PR0TP05",
      prodName: "VIRGINIA PREMIER ADVANTAGE PLATINUM",
      recieveDate: "04/30/2021",
    },
  ],
  CLOSED: [
    {
      activationDate: null,
      ageingDays: 0,
      applId: 2125,
      applStatus: "CANCELED",
      applType: "NMA",
      assignedToUser: "",
      birthDate: "09/05/1938",
      firstName: "PAMELA",
      lastName: "ROBTEST",
      medicareId: "1W11PR0TP05",
      prodName: "VIRGINIA PREMIER ADVANTAGE PLATINUM",
      recieveDate: "04/30/2021",
    },
  ],
};

const header = [
  { key: "planId", value: "planId" },
  { key: "name", value: "name" },
  { key: "rating", value: "rating" },
  { key: "rating", value: "rating" },
  { key: "ratingComment", value: "ratingComment" },
  { key: "monthlyPremium", value: "monthlyPremium" },
  { key: "estimatedYearlyCosts", value: "Estimated Yearly Costs" },
  { key: "ambulance", value: "Ambulance" },
  { key: "premium", value: "Premium" },
  { key: "deductible", value: "Deductible" },
  { key: "outOfPocketMax", value: "Out-of-pocket max" },
  { key: "doctorServices", value: "Doctor services" },
  { key: "testsLabsAndImaging", value: "Tests, labs, & imaging" },
  { key: "hospitalServices", value: "Hospital services" },
  { key: "skilledNursingFacility", value: "Skilled nursing facility" },
  { key: "preventiveServices", value: "Preventive services" },
  { key: "therapyServices", value: "Therapy services" },
  { key: "mentalHealthServices", value: "Mental health services" },
  {
    key: "opioidTrtmntProgramServices",
    value: "Opioid treatment program services",
  },
  { key: "opioidTrtmntServices", value: "Opioid treatment Services" },
  { key: "otherServices", value: "Other services" },
  { key: "hearing", value: "Hearing" },
  { key: "preventiveDental", value: "Preventive dental" },
  { key: "comprehensiveDental", value: "Comprehensive dental" },
  { key: "vision", value: "Vision" },
  { key: "moreBenefits", value: "More benefits" },
  {
    key: "medApprNonOpioidPainMgmtServices",
    value: "medAppr NonOpioid Pain Mgmt Services",
  },
  { key: "partBDrugs", value: "Part B drugs" },
  { key: "optionalPackages", value: "Optional Packages" },
  { key: "prescriptionDrugs", value: "Prescription Drugs" },
  { key: "stdRtlCostSharing", value: "Standard Retail Cost-Sharing" },
  { key: "stdMailCostSharing", value: "Standard Mail Cost-Sharing" },
  { key: "prefRtlCostSharing", value: "Preferred Retail Cost-Sharing" },
];
const header_supplement_Deductible = [
  { key: "firstSixtyDaysOfCare", value: "First 60 days of care" },
  { key: "daysSixtyOneToNinty", value: "Days 61 — 90" },
  {
    key: "daysNintyOneToOneFifty",
    value: "Days 91 — 150 (Lifetime Reserve Days)",
  },
  {
    key: "additionalThreeSixtyFiveDays",
    value: "Once lifetime reserve days are used: Additional 365 days",
  },
  {
    key: "byndAdditionalThreeSixtyFiveDays",
    value: "Beyond the additional 365 days",
  },
  { key: "firstTwentyDays", value: "First 20 days" },
  { key: "twentyOneThruHundredDay", value: "21st thru 100th day" },
  { key: "hundredOneDayAndAfter", value: "101st day and after" },
];
const header_supplement_BloodA = [
  { key: "snfcFirstThreePints", value: "First 3 pints" },
  { key: "snfcAdditionalAmounts", value: "Additional amounts" },
];
const header_supplement_Hospice = [
  {
    key: "hospiceCare",
    value: "You must meet Medicare’s requirements, including a doctor’s certification of terminal illness",
  },
  {
    key: "meFirstTwoNotThreeApprovedAmt",
    value: "First $203 of Medicare-approved amounts***",
  },
  {
    key: "meRemainderOfApprovedAmt",
    value: "Remainder of Medicare-approved amounts",
  },
  {
    key: "mePartBExcessCharges",
    value: "Part B excess charges (above Medicare-approved amounts)",
  },
];
const header_supplement_BloodB = [
  { key: "meFirstThreePints", value: "First 3 pints" },
  {
    key: "meNextTwoNotThreeApprovedAmt",
    value: "Next $203 of Medicare-approved amounts",
  },
  {
    key: "meBloodRemainderApprovedAmt",
    value: "Blood - Remainder of Medicare-approved amounts",
  },
];
const header_supplement_Clinical = [
  { key: "testsForDiagnosticServices", value: "Tests for diagnostic services" },
];
const header_supplement_Home = [
  {
    key: "medicallyNecessarySkilled",
    value: "Medically necessary skilled care services and medical supplies",
  },
  {
    key: "durableMedicalEquipment",
    value: "Durable medical equipment: First $203 of Medicare-approved amounts",
  },
  {
    key: "remainderOfMedicare",
    value: "Remainder of Medicare-approved amounts",
  },
];
const header_supplement_Other = [
  {
    key: "firstTwoFiftyEachCalendarYear",
    value: "First $250 each calendar year",
  },
  { key: "remainderOfCharges", value: "Remainder of charges" },
];
export {
  planDetails,
  planCards,
  planDetailHeader,
  planDet,
  chartData,
  header,
  chartDataCategory,
  header_supplement_Deductible,
  header_supplement_BloodA,
  header_supplement_Hospice,
  header_supplement_BloodB,
  header_supplement_Clinical,
  header_supplement_Home,
  header_supplement_Other
};
